/* global axios */

import ApiClient from './ApiClient';

class Usages extends ApiClient {
  constructor() {
    super('usages', { accountScoped: true });
  }

  getUsage() {
    return axios.get(this.url);
  }

  getTokenChart(params = {}) {
    return axios.get(`${this.url}/token_chart`, { params });
  }
}

export default new Usages();
